export default __webpack_public_path__ + "static/media/waveu.8f83db2d.svg";